import React from "react";
import useScrollAnimation from "./components/hooks/scroll-animation.js";
// import HeaderTop from "./layouts/header/header-top.jsx";
import Header from "./layouts/header/header.jsx";
import Hero from "./components/home/hero.jsx";
import Products from "./components/home/products.jsx";
import Services from "./components/home/service.jsx";
import About from "./components/home/about.jsx";
import Features from "./components/home/features.jsx";
import Testimonials from "./components/home/testimonials.jsx";
import Contact from "./components/home/contact.jsx";
import Map from "./components/home/map.jsx";
import Footer from "./layouts/footer/footer.jsx";
import Bottomnav from "./layouts/mobile-menu/bottom-nav.jsx";
import FloatingContact from "./components/common/floating-icon.jsx";

function App() {
  // Initialize standard-native scroll observer animations
  useScrollAnimation();

  const handleMenuClick = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <>
      {/* <HeaderTop /> */}
      <Header onMenuClick={handleMenuClick} />

      <main>
        <Hero onMenuClick={handleMenuClick} />
        <Products />
        <Services />
        <About />
        <Features />
        <Testimonials />
        <Contact />
        <Map />
      </main>

      <Footer onMenuClick={handleMenuClick} />

      {/* PWA Mobile Accessibility Navigation */}
      <Bottomnav onMenuClick={handleMenuClick} />
      <FloatingContact />
    </>
  );
}

export default App;


// import React from "react";
// import HeaderTop from "./layouts/header/header-top.jsx";
// import Header from "./layouts/header/header";
// import Hero from "./components/home/hero.jsx";
// import About from "./components/home/about.jsx";
// import Services from "./components/home/service.jsx";
// import Products from "./components/home/products.jsx";
// import Features from "./components/home/features.jsx";
// import Testimonials from "./components/home/testimonials.jsx";
// import Contact from "./components/home/contact.jsx";
// import Footer from "./layouts/footer/footer";
// import Bottomnav from "./layouts/mobile-menu/bottom-nav.jsx";
// import FloatingContact from "./components/common/floating-icon.jsx";


// function App() {
  
//   const handleMenuClick = (section) => {
//     const element = document.getElementById(section);
//     if (element) {
//       element.scrollIntoView({ behavior: "smooth" });
//     }
//   };

//   return (
//     <>
//       <HeaderTop />
//       <Header />

//       <Hero />
//       <Products />
//       <Services />
//       <About />
//       <Features />
//       <Testimonials />
//       <Contact />

//       <Footer />

//       {/* PWA Mobile Bottom Nav */}
//       <Bottomnav onMenuClick={handleMenuClick} />
//       <FloatingContact />
//     </>
//   );
// }

// export default App;
